import gql from 'graphql-tag'
import { BaseDocumentFragment } from '@/graphql/fragments/documents'

export const mutation = gql`
  ${BaseDocumentFragment}
  mutation updateDocument($id: Int!, $fields: documents_document_set_input!) {
    record: update_documents_document_by_pk(pk_columns: {id: $id}, _set: $fields) {
      ...BaseDocument
    }
  }
`

export default mutation
